import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

import androidImage1 from '../assets/images/services/it/EMS1.jpg';
import androidImage2 from '../assets/images/services/it/CCTV2.jpg';
import androidImage3 from '../assets/images/services/it/EMS.jpg';
import androidImage4 from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';

import softwareVideo from '../assets/videos/software/android-development.mp4';

import androidBenefitsImage from '../assets/images/software/android-development.jpg';

const SoftwareAndroidDevelopmentPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Android Development" description="Android app development services in DRC. Custom mobile applications for businesses by Cool & Care." keywords="Android development DRC, mobile app development, custom apps, business apps Kinshasa" />
      <ServiceSchema name="Android Development" description="Custom Android mobile application development for businesses." url="/software-android-development" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'Android Development', url: '/software-android-development' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareAndroidDevelopment.name')}
      serviceDescription={t('servicePage.services.softwareAndroidDevelopment.description')}
      videoUrl={softwareVideo}
      productImages={[
        androidImage1,
        androidImage2,
        androidImage3,
        androidImage4
      ]}
      features={t('servicePage.services.softwareAndroidDevelopment.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareAndroidDevelopment.benefits', { returnObjects: true }) as string[]}
      benefitsImage={androidBenefitsImage}
    />
    </>
  );
};

export default SoftwareAndroidDevelopmentPage;

